// Free play (#46): a sandbox for the desktop trainer. Random weather and work
// orders keep it fresh, and the controls panel changes the farm live: hub
// traffic, alerts, wind, aircraft. It never ends by itself (unless the player
// lets incidents end it) and nothing in it counts toward the career. Pure.

import { LEVELS, COMPASS, TIME_SLOTS, FIELDS } from '../config/constants.js';

export const FREE_DEFAULTS = Object.freeze({
  traffic: 'operator',  // 'off' or a LEVELS id
  randomAlerts: true,   // field and hub alerts at random (they can always be triggered by hand)
  randomWeather: true,  // new random wind every day
  incidentsEnd: false,  // three incidents end the session
});
export const FREE_MAX_AIRCRAFT = 6;
export const TRAFFIC_OPTIONS = [{ id: 'off', label: 'Off' }, ...LEVELS.map((l) => ({ id: l.id, label: l.label }))];

export function isValidFree(v) {
  return Boolean(v) && TRAFFIC_OPTIONS.some((o) => o.id === v.traffic)
    && ['randomAlerts', 'randomWeather', 'incidentsEnd'].every((k) => typeof v[k] === 'boolean');
}

/**
 * A random wind for each time of day: mostly light to moderate, now and
 * then strong enough to ground the lightest drones or close the spray window.
 */
export function randomWind(random) {
  return Object.fromEntries(TIME_SLOTS.map((slot) => [slot, {
    speed: Math.round(1 + random() * random() * 26),
    dir: COMPASS[Math.floor(random() * COMPASS.length)].deg,
  }]));
}

/** 2 to 4 random fields, in FIELDS order. */
export function randomWorkOrder(random) {
  const order = FIELDS.map((_, i) => i).sort(() => random() - 0.5);
  const n = 2 + Math.floor(random() * 3);
  return order.slice(0, n).sort((a, b) => a - b);
}

/** Change the hub traffic live: 'off', or a level's filing rate, cap and warning. */
export function setTrafficLevel(s, id) {
  if (id === 'off') {
    s.trafficEnabled = false;
    s.plans = []; // filed plans are withdrawn; drones already up land as planned
    return;
  }
  const level = LEVELS.find((l) => l.id === id);
  if (!level) return;
  s.trafficEnabled = true;
  Object.assign(s, {
    level: level.id,
    leadMin: level.leadMin,
    leadMax: level.leadMax,
    minSpawnInterval: level.minSpawnInterval,
    trafficCap: level.trafficCap,
    spawnInterval: level.spawnInterval,
    maxTraffic: level.maxTraffic,
  });
  if (s.alerts) Object.assign(s.alerts, { interval: level.alertInterval, max: level.maxAlerts });
}
